import type { Resource } from '../../';
export const giftcard_cart_to: Resource = {"default":"To"};
